import React, { memo } from 'react'
import moment from 'moment'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { IAvailableTruckDays } from 'apps/fleet-planner/utils/bookableShipmentSavedSearch'
import { FormattedDateTime } from 'transfix-ui'
import {
  BookableShipmentSavedSearchAlertRow,
  BookableShipmentSavedSearchAlertRowProps,
} from './BookableShipmentSavedSearchAlertRow'
import { BookableShipmentSavedSearchAlertRowItems } from './BookableShipmentSavedSearchAlertRowItems'

interface IBookableShipmentSavedSearchAvailableTrucksRowProps
  extends Pick<IAvailableTruckDays, 'filteredSearches' | 'pickupStartDate'>,
    Pick<BookableShipmentSavedSearchAlertRowProps, 'onClick'> {
  isSharedSavedSearch: boolean
}

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: brandColors.coolGray1,
  },
  text: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
}))

export const BookableShipmentSavedSearchAvailableTrucksRow = memo<
  IBookableShipmentSavedSearchAvailableTrucksRowProps
>(({ filteredSearches, isSharedSavedSearch, onClick, pickupStartDate }) => {
  const classes = useStyles()
  const rowClickHandler = () => {
    if (onClick) {
      onClick()
    }
  }
  return (
    <Box>
      <Box pl={0.75} pb={2}>
        <Typography variant='h2'>
          {' '}
          <FormattedDateTime
            datetime={pickupStartDate}
            format='weekdayDateAndYear'
            displayTimezone={moment.tz.guess()}
          />
        </Typography>
      </Box>
      {/* Saved search rows */}
      {filteredSearches.length > 0 &&
        filteredSearches.map(savedSearch => {
          return isSharedSavedSearch ? (
            <Box p={0.75} onClick={rowClickHandler}>
              <BookableShipmentSavedSearchAlertRowItems
                isSharedSavedSearch={isSharedSavedSearch}
                savedSearch={savedSearch}
              />
            </Box>
          ) : (
            <BookableShipmentSavedSearchAlertRow
              onClick={rowClickHandler}
              savedSearch={savedSearch}
              key={`saved-search-row-${savedSearch.id}`}
            />
          )
        })}
      {/* Empty state */}
      {filteredSearches.length === 0 && (
        <Box className={classes.container} p={0.75}>
          <Box className={classes.text}>
            <Typography variant='subtitle1'>No Availability Added</Typography>
          </Box>
        </Box>
      )}
    </Box>
  )
})
